export function get2DSpectrumErrorValue(spectrum) {
    const { data, info } = spectrum;
    const { minX, maxX, minY, maxY } = info.isFid
        ? data.re
        : data.rr;
    const x = Math.abs(maxX - minX) / 10000;
    const y = Math.abs(maxY - minY) / 10000;
    return { x, y };
}
//# sourceMappingURL=get2DSpectrumErrorValue.js.map